/**
 * Created by stonewang on 2017/8/29.
 */
import {config, request} from 'Utils';

export function list(param) {
  return request(`${config.server}/api/v1/dms/channel/list`, {
    method: 'post',
    body: {...param},
  });
}
/*二级客户列表*/
export function list2(param) {
  return request(`${config.server}/api/v1/dms/employee/secondList`, {
    method: 'post',
    body: {...param},
  });
}
/*二级客户列表*/
export function list3(param) {
  return request(`${config.server}/api/v1/dms/category/list`, {
    method: 'post',
    body: {...param},
  });
}
/*二级客户列表第二种*/
export function list4(param) {
  return request(`${config.server}/api/v1/dms/trans/otherPro/otherCategory`, {
    method: 'post',
    body: {...param},
  });
}

/*获取子库列表*/
export function getSubStoreList(param) {
  return request(`${config.server}/api/v1/dms/dmsTianSubStore/listByPage`, {
    method: 'post',
    body: {...param},
  });
}

export function add(param) {
  /*
   {
   name (string, optional): 渠道名称 ,
   code (string, optional): 渠道编号 ,
   shortName (string, optional): 渠道简称,
   parentId (integer, optional): 上级渠道 ,
   rank (integer, optional): 等级.青铜、白银、黄金、钻石 ,
   channelType (integer, optional): 渠道类型.销售公司、代理商、经销商、分销商 ,
   contacts (string, optional): 联系人 ,
   contactsMobile (string, optional): 联系人手机 ,
   province (string, optional): 省份 公司地址,
   city (string, optional): 城市 公司地址,
   county (string, optional): 区县 公司地址,
   address (string, optional): 详细地址 ,
   areaId (integer, optional): 归属区域 ,
   employeeId (integer, optional): 所属业务员 ,
   productTypeIdList (Array[integer], optional): 产品类别ID集合 ,
   areaIdList (Array[integer], optional): 销售地区ID集合 ,
   compnyPhone (string, optional): 公司电话 ,
   companyFax (string, optional): 公司传真 ,
   employeeNum (integer, optional): 公司员工数量 ,
   companyWebsite (string, optional): 公司网站 ,
   companyCeo (string, optional): CEO ,
   companyIncome (number, optional): 公司年收入 ,
   }
   **/
  return request(`${config.server}/api/v1/dms/employee/insertSecond`, {
    method: 'post',
    body: param,
  });
}

/*新建二级产品 */
export function add2(param) {
  return request(`${config.server}/api/v1/dms/trans/otherPro/insert`, {
    method: 'post',
    body: param,
  });
}
export function update(param) {
  /*
   {
   id (integer, optional): 渠道ID, 修改数据是传入
   name (string, optional): 渠道名称 ,
   code (string, optional): 渠道编号 ,
   shortName (string, optional): 渠道简称,
   parentId (integer, optional): 上级渠道 ,
   rank (integer, optional): 等级.青铜、白银、黄金、钻石 ,
   channelType (integer, optional): 渠道类型.销售公司、代理商、经销商、分销商 ,
   contacts (string, optional): 联系人 ,
   contactsMobile (string, optional): 联系人手机 ,
   province (string, optional): 省份 公司地址,
   city (string, optional): 城市 公司地址,
   county (string, optional): 区县 公司地址,
   address (string, optional): 详细地址 ,
   areaId (integer, optional): 归属区域 ,
   employeeId (integer, optional): 所属业务员 ,
   productTypeIdList (Array[integer], optional): 产品类别ID集合 ,
   areaIdList (Array[integer], optional): 销售地区ID集合 ,
   compnyPhone (string, optional): 公司电话 ,
   companyFax (string, optional): 公司传真 ,
   employeeNum (integer, optional): 公司员工数量 ,
   companyWebsite (string, optional): 公司网站 ,
   companyCeo (string, optional): CEO ,
   companyIncome (number, optional): 公司年收入 ,
   }
   **/
  return request(`${config.server}/api/v1/dms/channel/update`, {
    method: 'post',
    body: param,
  });
}
export function detail(param) {
  return request(`${config.server}/api/v1/dms/channel/detail?id=${param}`, {
    method: 'post',
  });
}

/*二级客户列表*/
export function detail2(param) {
  return request(`${config.server}/api/v1/dms/employee/secondList`, {
    method: 'post',
    body: {...param},
  });
}
/** 删除二级客户
 * {
    "ids": [               // 员工id集合
        "12342323","232435"
    ]
}
 * */
export function deleteSecondCustomer(param) {
  return request(`${config.server}/api/v1/dms/employee/delete`, {
    method: 'post',
    body: param,
  });
}
//渠道列表（提供给下拉框）
export function getListSelect(param) {
  return request(`${config.server}/api/v1/dms/channel/getListSelect`);
}
export function account(){
  return request(`${config.server}/api/v1/dms/employee/getSecondAccount`);
}
export function getDetail(param) {
  return request(`${config.server}/api/v1/dms/trans/otherPro/listOne`, {
    method: 'get',
    body: param,
  });
}
export function customerType(param) {
  return request(`${config.server}/api/v1/dms/dictionayDependent/sKeylist`, {
    method: 'get',
    body: param,
  });
}



// WEBPACK FOOTER //
// ./src/service/customer/index.js